module.exports = __webpack_public_path__ + "img/about-icon0.5b51a982.png";